var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEngameLogo = function SvgEngameLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 123.766 65.657"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "engame_logo_svg__a",
    x1: 2.463,
    x2: 3.463,
    y1: 0.926,
    y2: 0.926,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#fff",
    stopOpacity: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#fff",
    stopOpacity: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#fff",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#fff",
    stopOpacity: 0.196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#fff",
    stopOpacity: 0.306
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    stopColor: "#fff",
    stopOpacity: 0.443
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fff",
    stopOpacity: 0.608
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#fff",
    stopOpacity: 0.792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#engame_logo_svg__a",
    id: "engame_logo_svg__d",
    x1: 4.417,
    x2: 5.166,
    y1: 1.769,
    y2: 1.769
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#engame_logo_svg__a",
    id: "engame_logo_svg__f",
    x1: 0.446,
    x2: 1.446,
    y1: 0.885,
    y2: 0.885
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#engame_logo_svg__a",
    id: "engame_logo_svg__g",
    x1: 1.11,
    x2: 1.859,
    y1: 1.679,
    y2: 1.679
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#engame_logo_svg__a",
    id: "engame_logo_svg__i",
    x1: 2.5,
    x2: 3.5,
    y1: 2.938,
    y2: 2.938
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#engame_logo_svg__a",
    id: "engame_logo_svg__j",
    x1: 4.478,
    x2: 5.227,
    y1: 6.176,
    y2: 6.176
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "engame_logo_svg__b",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#7a7a7a",
    stopOpacity: 0.961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#838383",
    stopOpacity: 0.847
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#909090",
    stopOpacity: 0.659
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#a3a3a3",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#bcbcbc",
    stopOpacity: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c1c1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "engame_logo_svg__c",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff00e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#fd00de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#f900d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#f200ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9009c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "engame_logo_svg__e",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffea1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#ffe51c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#ffd71c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#ffc11e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffae1f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "engame_logo_svg__h",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00deff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#01d9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#05cbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    stopColor: "#0cb5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1599ff"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8994"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8993"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8998"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#engame_logo_svg__b)",
    d: "M56.47 137.525a16.392 16.392 0 1 1-16.392-16.392 16.393 16.393 0 0 1 16.392 16.392",
    "data-name": "Path 25017",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    },
    transform: "translate(-16.741 -120.295)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8992"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8987"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.937 14.993A14.993 14.993 0 1 1 21.944 0a14.993 14.993 0 0 1 14.993 14.993",
    "data-name": "Path 25023"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8986"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8984"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#engame_logo_svg__c)",
    d: "M48.449 143.691a12.982 12.982 0 1 1 0-18.359 12.98 12.98 0 0 1 0 18.359",
    "data-name": "Path 25024",
    transform: "translate(-17.325 -119.519)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8985"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#engame_logo_svg__a)",
    d: "M42.5 127.215a10.975 10.975 0 1 1-10.974 10.975A10.975 10.975 0 0 1 42.5 127.215",
    "data-name": "Path 25025",
    transform: "translate(-20.557 -123.026)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#engame_logo_svg__d)",
    d: "M49.4 133.969c3.7 0 6.692 2.244 6.692 5.011s-3 5.013-6.692 5.013-6.7-2.244-6.7-5.013 3-5.011 6.7-5.011",
    "data-name": "Path 25026",
    transform: "translate(-27.452 -127.192)"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#fff9f9",
    strokeWidth: 2,
    "data-name": "Group 8999",
    transform: "translate(14.158 7.201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.011 7.514v-.917A.24.24 0 0 1 .22 6.34a.257.257 0 0 1 .257.257v1.03a.24.24 0 0 1-.209.257.29.29 0 0 1-.257-.37Z",
    "data-name": "Path 754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.012 3.62V2.606a.24.24 0 0 1 .209-.257c.193 0 .257.129.322.322v.917a.29.29 0 0 1-.257.322.306.306 0 0 1-.274-.29Z",
    "data-name": "Path 755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.012 1.674v-.177A1.35 1.35 0 0 1 .269.58.43.43 0 0 1 .72.451a.42.42 0 0 1 0 .467 1.06 1.06 0 0 0-.1.579v.193a.35.35 0 0 1-.318.214.257.257 0 0 1-.29-.225Z",
    "data-name": "Path 756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.324.58h-.918a.258.258 0 1 1 0-.515h.982c.193 0 .322.129.257.257a.29.29 0 0 1-.322.257Z",
    "data-name": "Path 757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.628 4.634v.982a.29.29 0 0 1-.257.322.29.29 0 0 1-.257-.322v-.982a.29.29 0 0 1 .257-.322.29.29 0 0 1 .257.322Z",
    "data-name": "Path 758"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.496,
    height: 0.515,
    "data-name": "Rectangle 2131",
    rx: 0.16,
    transform: "translate(5.177)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.956 9.734c0 .193-.145.257-.338.257h-.981a.257.257 0 0 1-.322-.193.274.274 0 0 1 .209-.322h1.094a.32.32 0 0 1 .338.258Z",
    "data-name": "Path 760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.059.322a.29.29 0 0 1 .322-.258h.978a.258.258 0 1 1 0 .515h-.962a.29.29 0 0 1-.338-.257Z",
    "data-name": "Path 761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.186.322a.257.257 0 0 1 .257-.257 1.2 1.2 0 0 1 .531 0h.451a.225.225 0 0 1 .257.209.257.257 0 0 1-.257.257h-.982C1.25.579 1.186.453 1.186.322Z",
    "data-name": "Path 762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.865 9.235a.225.225 0 0 1 0 .338.274.274 0 0 1-.354 0A1.29 1.29 0 0 1 .06 8.527a.258.258 0 0 1 .515 0 .92.92 0 0 0 .29.708Z",
    "data-name": "Path 764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.167.789a.32.32 0 0 1-.08-.4.257.257 0 0 1 .354 0 1.45 1.45 0 0 1 .515.982c0 .257 0 .386-.257.386s-.257-.129-.257-.322a.9.9 0 0 0-.274-.644Z",
    "data-name": "Path 765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.005 2.477v.917a.29.29 0 0 1-.257.322c-.193 0-.257-.129-.257-.322v-.981c0-.193.129-.322.257-.257s.257.128.257.321Z",
    "data-name": "Path 766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.673 11.101c-.515-.322-1.11-.644-1.609-.917a1.4 1.4 0 0 1-.6-1.883v-.209a1.6 1.6 0 0 1-.628-.708 1.06 1.06 0 0 1 .467-1.11.965.965 0 0 1 1.175.129c.386.386.788.788 1.175 1.11a.274.274 0 1 1-.386.386L5.225 6.851a.6.6 0 0 0-.4-.193.29.29 0 0 0-.322.257.53.53 0 0 0 .13.536l.982.982.4.386a.29.29 0 0 1-.4.4 5.6 5.6 0 0 1-.788-.6.87.87 0 0 0 .274 1.046 22 22 0 0 0 2.172 1.175 2.62 2.62 0 0 0 2.092 0 2.687 2.687 0 0 0 1.609-3.476v-.113a6.9 6.9 0 0 0-1.77-2.558.5.5 0 0 0-.644 0c-.193.129-.322.129-.4 0a.32.32 0 0 1 0-.451.965.965 0 0 1 1.3 0 6.86 6.86 0 0 1 2.092 3.218 3.22 3.22 0 0 1-2.188 4.1l-.306.08a3.03 3.03 0 0 1-2.385-.539Z",
    "data-name": "Path 767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.572 6.773v7.289a1.513 1.513 0 0 1-1.448 1.513H7.06a1.448 1.448 0 0 1-1.61-1.513v-1.609c0-.338.209-.4.322-.4s.338 0 .338.4v1.432a.76.76 0 0 0 .177.611.82.82 0 0 0 .547.306h7.116a.837.837 0 0 0 .917-.74v-7.08a.84.84 0 0 0-.177-.611.8.8 0 0 0-.563-.29h-1.48a.4.4 0 0 1-.4-.322c0-.338.338-.338.467-.338h1.368a1.43 1.43 0 0 1 1.03.37 1.48 1.48 0 0 1 .467.982Z",
    "data-name": "Path 768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.242 6.017c-.129-.129 0-.257 0-.386a.66.66 0 0 1 .644-.322.98.98 0 0 1 .724.257l.917.917c.129.129.129.322 0 .386a.24.24 0 0 1-.338 0l-.839-.852a.53.53 0 0 0-.724 0Z",
    "data-name": "Path 759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.673 4.698c0-.193.257-.257.531-.257a.97.97 0 0 1 .708.257l1.046 1.046c.129.129.129.338 0 .4s-.257.129-.386 0l-.917-.917c-.257-.274-.386-.274-.66 0s-.322.129-.386 0a.53.53 0 0 1 .064-.529Z",
    "data-name": "Path 763"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8997"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#engame_logo_svg__b)",
    d: "M110.424 198.782a16.392 16.392 0 1 1-16.393-16.392 16.39 16.39 0 0 1 16.393 16.392",
    "data-name": "Path 25018",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    },
    transform: "translate(-77.639 -149.516)"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8991",
    transform: "translate(.204 31.762)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.993,
    cy: 14.993,
    r: 14.993,
    fill: "#fff",
    "data-name": "Ellipse 11227"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8990"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8988"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#engame_logo_svg__e)",
    d: "M105.049 202.635a12.982 12.982 0 1 1 0-18.359 12.98 12.98 0 0 1 0 18.359",
    "data-name": "Path 25027",
    transform: "translate(-80.876 -178.462)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8989"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#engame_logo_svg__f)",
    d: "M99.1 186.159a10.975 10.975 0 1 1-10.975 10.975A10.975 10.975 0 0 1 99.1 186.159",
    "data-name": "Path 25028",
    transform: "translate(-84.108 -181.97)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#engame_logo_svg__g)",
    d: "M106 192.913c3.7 0 6.692 2.244 6.692 5.012s-3 5.012-6.692 5.012-6.692-2.244-6.692-5.012 2.992-5.012 6.692-5.012",
    "data-name": "Path 25029",
    transform: "translate(-91.004 -186.136)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.808 14.145 12.514 7.56a.944.944 0 0 0-1.449.79v13.346a.92.92 0 0 0 .5.834.72.72 0 0 0 .439 0 .83.83 0 0 0 .5-.132l10.3-6.585a.99.99 0 0 0 .417-.812.9.9 0 0 0-.413-.856m-9.812 5.73V9.996l7.618 4.961Z",
    "data-name": "Path 25030"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8996"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#engame_logo_svg__b)",
    d: "M110.424 83.247a16.392 16.392 0 1 1-16.393-16.392 16.39 16.39 0 0 1 16.393 16.392",
    "data-name": "Path 25016",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    },
    transform: "translate(-37.094 -60.88)"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8983"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70.735 19.863A14.993 14.993 0 1 1 55.742 4.87a14.993 14.993 0 0 1 14.993 14.993",
    "data-name": "Path 25019"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8982"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8980"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#engame_logo_svg__h)",
    d: "M105.049 84.984a12.982 12.982 0 1 1 0-18.359 12.98 12.98 0 0 1 0 18.359",
    "data-name": "Path 25020",
    transform: "translate(-40.127 -55.941)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8981"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#engame_logo_svg__i)",
    d: "M99.1 68.507a10.975 10.975 0 1 1-10.974 10.975A10.975 10.975 0 0 1 99.1 68.507",
    "data-name": "Path 25021",
    transform: "translate(-43.359 -59.448)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#engame_logo_svg__j)",
    d: "M106 75.261c3.7 0 6.692 2.244 6.692 5.012s-3 5.012-6.692 5.012-6.692-2.244-6.692-5.012 2.992-5.012 6.692-5.012",
    "data-name": "Path 25022",
    transform: "translate(-50.255 -63.614)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Group 9000"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.776 14.86.864.522a.249.249 0 1 0 .362-.342l-.864-.542a.28.28 0 0 0-.362 0 .3.3 0 0 0 0 .362",
    "data-name": "Path 770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.068 13.795.864.522a.242.242 0 1 0 .342-.342l-.864-.542a.26.26 0 0 0-.362 0 .28.28 0 0 0 .02.362",
    "data-name": "Path 771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.504 16.315.864.522a.249.249 0 1 0 .362-.342l-.864-.542a.3.3 0 0 0-.362 0 .28.28 0 0 0 0 .362",
    "data-name": "Path 772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.477 12.189a.24.24 0 0 0 .342 0 .26.26 0 0 0 0-.362l-.864-.522a.248.248 0 0 0-.261.422Z",
    "data-name": "Path 773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.232 17.397.864.522a.5.5 0 0 1 .1.482.26.26 0 0 0 .121.281.26.26 0 0 0 .321-.181 1.02 1.02 0 0 0 0-.824.26.26 0 0 0-.092-.117l-1.033-.607a.28.28 0 0 0-.362.1.26.26 0 0 0 .081.344",
    "data-name": "Path 774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.341 12.731.864.522a.242.242 0 1 0 .342-.342l-.944-.623a.24.24 0 0 0-.342 0 .26.26 0 0 0 .08.442Z",
    "data-name": "Path 775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.942 12.53a.26.26 0 0 0 .342 0l.546-.842a.3.3 0 0 0 0-.362.26.26 0 0 0-.362 0l-.522.864a.26.26 0 0 0 0 .342Z",
    "data-name": "Path 776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.091 11.043a.26.26 0 0 0 0-.362h-.2a.92.92 0 0 0-.763 0 .241.241 0 0 0 0 .442.26.26 0 0 0 .241 0 .46.46 0 0 1 .482 0 .24.24 0 0 0 .241-.08Z",
    "data-name": "Path 779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.877 14.318a.24.24 0 0 0 .342 0l.542-.864a.26.26 0 0 0-.1-.342.24.24 0 0 0-.342 0l-.522.864a.24.24 0 0 0 .08.342",
    "data-name": "Path 780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.813 16.045a.24.24 0 0 0 .342 0l.522-.864a.248.248 0 1 0-.422-.261l-.542.864a.26.26 0 0 0 .1.261",
    "data-name": "Path 781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.727 17.772a.26.26 0 0 0 .362 0l.522-.864a.278.278 0 0 0-.422-.362l-.623.884a.26.26 0 0 0 .161.342",
    "data-name": "Path 782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.421 18.519-.535.858a.5.5 0 0 0 .13.475.26.26 0 0 1 .02.306.26.26 0 0 1-.37-.015 1.02 1.02 0 0 1-.378-.727.5.5 0 0 1 .045-.208l.636-.955a.28.28 0 0 1 .367-.075.26.26 0 0 1 .085.34",
    "data-name": "Path 25031"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.546 22.251a.26.26 0 0 1 .241-.1h.5l-1.685-1.587-.522 2.23.522-.221a.28.28 0 0 1 .221 0 .26.26 0 0 1 .1.141l.6 1.888.623-.161-.6-1.868a.28.28 0 0 1 0-.321Z",
    "data-name": "Path 783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.019 19.882-10.426-6.409a1.045 1.045 0 0 0-1.406.342l-4.52 7.332a.984.984 0 0 0 .321 1.386l10.366 6.409a1 1 0 0 0 1.466-.342l4.54-7.332a1.045 1.045 0 0 0-.342-1.386Zm-7.312-.944a.24.24 0 0 1 .342 0 .26.26 0 0 1 .1.342l-.4.643a.256.256 0 1 1-.362-.362Zm-2.35 1.225-.763-.3a.26.26 0 0 1 0-.321.24.24 0 0 1 .321-.141l.723.3a.26.26 0 0 1 .141.321.241.241 0 0 1-.422.141m.964-.824a.2.2 0 0 1-.181 0 .22.22 0 0 1-.121-.141l-.241-1.066a.26.26 0 0 1 .181-.3.28.28 0 0 1 .321.2l.241 1.045a.26.26 0 0 1-.2.261Zm2.17 5.444-1.1.261a.22.22 0 0 1-.2 0 .26.26 0 0 1-.121-.141l-.462-1.808-.723.5a.24.24 0 0 1-.281 0 .26.26 0 0 1-.1-.261l.763-3.315a.3.3 0 0 1 .181-.2.26.26 0 0 1 .241 0l2.612 2.491a.24.24 0 0 1 0 .281.22.22 0 0 1-.261.141h-.884l.563 1.748a.22.22 0 0 1 0 .2.36.36 0 0 1-.221.1Z",
    "data-name": "Path 784"
  }))))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#100e0e",
    "data-name": "Group 8995"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.933 41.352v3.775h7.893v3.112h-7.893v4.469h7.893l.05 3.075H36.298l-.05-17.556h11.714v3.125Z",
    "data-name": "Path 748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.431 46.07v-3.585h3.486c.075.336.124 1.531.149 1.954a3.96 3.96 0 0 1 3.735-1.967c2.614 0 4.32 1.78 4.32 5.054v8.291h-3.61v-7.892c0-1.469-.5-2.49-2.091-2.49s-2.4.859-2.4 3.15v7.27h-3.614Z",
    "data-name": "Path 749"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.336 55.328c0 4.233-1.569 6.922-6.573 6.922-4.818 0-5.776-2.7-5.9-4.183h3.735a2.09 2.09 0 0 0 2.328 1.519c2.378 0 2.826-1.444 2.826-4.033v-1.74a3.9 3.9 0 0 1-3.735 1.855c-3.486 0-5.465-2.851-5.465-6.411 0-4.133 2.49-6.959 5.776-6.959 2.266 0 3.212 1.071 3.411 1.693 0-.361.124-1.17.149-1.382h3.461v3.8Zm-9.013-6.22c0 2.278 1.133 3.623 2.751 3.623 2.2 0 2.789-1.519 2.789-3.735s-.386-3.735-2.714-3.735c-1.581-.025-2.826 1.2-2.826 3.834Z",
    "data-name": "Path 750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.447 52.407a31 31 0 0 0 .149 3.423H85.12a6 6 0 0 1-.187-1.245c-.473.734-1.369 1.593-3.735 1.593a4.083 4.083 0 0 1-4.531-4.14c0-3.013 2.415-4.394 6.3-4.394h1.892v-.809c0-.946-.336-1.867-2.029-1.867s-1.892.66-2.054 1.618H77.29c.2-2.353 1.656-4.245 5.677-4.233 3.535 0 5.465 1.407 5.465 4.556Zm-3.585-2.6H83.39c-2.216 0-3.025.672-3.025 1.954a1.693 1.693 0 0 0 1.9 1.78c2.316 0 2.6-1.618 2.6-3.361Z",
    "data-name": "Path 751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.62 46.07v-3.411h3.5a15 15 0 0 1 .137 1.581 4.11 4.11 0 0 1 3.733-1.892 3.47 3.47 0 0 1 3.411 2.017 4.58 4.58 0 0 1 3.983-2.03c2.3 0 4.2 1.419 4.2 4.855v8.715h-3.56v-8.3c0-1.245-.436-2.365-1.93-2.365s-2.166 1.008-2.166 3.038v7.557h-3.6v-8.1c0-1.369-.336-2.49-1.9-2.49s-2.191.921-2.191 3.187v7.382H90.62Z",
    "data-name": "Path 752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.97 50.004c0 1.643.834 3.262 2.652 3.262a2.09 2.09 0 0 0 2.3-1.407h3.66a5.776 5.776 0 0 1-6.063 4.27c-4.345 0-6.224-3.249-6.224-6.722 0-4.146 2.129-7.108 6.374-7.108 4.531 0 6.075 3.287 6.075 6.586a8 8 0 0 1 0 1.12Zm5.1-2.253c0-1.531-.647-2.826-2.49-2.826s-2.49 1.245-2.6 2.826Z",
    "data-name": "Path 753"
  }))));
};
export default SvgEngameLogo;